export interface GallerySlide {
  src: string
  alt: string
}

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/x291auT5SE6dgypoFyt39F/Captura_de_pantalla_2026-09-25_234625.png',
    alt: '12 demos you can teach directly from this page — ready-made instructor demonstration topics',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/maGEJYmcLx9CVJsu6HVQhw/Captura_de_pantalla_2026-09-25_234607.png',
    alt: "Don't copy the photo — analyze the elements: reference image analysis framework",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6BTouj9BA4GzNtech1Vv5W/Captura_de_pantalla_2026-09-25_234526.png',
    alt: 'Structure without harshness — full glam complexion map and placement order',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6VYKLo6AEgSYqtYeCDj3Vb/Captura_de_pantalla_2026-09-25_234507.png',
    alt: 'Depth without muddiness — structured smoky eye gradient map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3trc1ZDpmSMUYAswxbAXUp/Captura_de_pantalla_2026-09-25_234440.png',
    alt: 'Soft glam equals controlled intensity — natural, soft glam and full glam comparison',
  },
]
